export default __webpack_public_path__ + "static/media/hover.322ec8a9.png";